import { Form, Formik } from "formik";
import { type ReactNode, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { object, ref, string } from "yup";
import { passwordSchema } from "../../utils/constants/validation";
import PasswordInput from "../UI/PasswordInput";
import styles from "./AuthForm.module.css";
// @ts-expect-error pure js
import { axiosPublic } from "../../api";
import FormikSubmitButton from "../UI/FormikSubmitButton";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
import Callout from "../UI/Callout";
// @ts-expect-error pure js
import useAuth from "../../hooks/use-auth.js";

interface ResetPasswordValues {
  mail: string;
  password: string;
}

export default function AuthFormForgottenPasswordReconf() {
  const { buildAndSetAuth } = useAuth();
  const nav = useNavigate();
  const { token } = useParams();
  const [error, setError] = useState<ReactNode>("");

  async function resetPassword(values: ResetPasswordValues) {
    try {
      const data = {
        password: values.password,
      };
      const response = await axiosPublic.put("/init-password", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      buildAndSetAuth(response.data);
      nav("/");
    } catch (err: unknown) {
      const axiosError = err as { response?: { status: number } };
      if (axiosError?.response?.status === 401) {
        setError(
          <>
            Le lien de création de mot de passe a expiré.
            <br />
            <Link to={"/reset-password"}>
              Réinitialisez votre mot de passe.
            </Link>
          </>,
        );
      } else {
        setError(handleAPIError(err));
      }
    }
  }

  return (
    <Formik
      initialValues={{ mail: "", password: "" }}
      validationSchema={object({
        password: passwordSchema().required(" "),
        dPassword: string()
          .oneOf([ref("password")], "Les mots de passe doivent être identiques")
          .required(" "),
      })}
      onSubmit={resetPassword}
    >
      <Form className={styles.form}>
        <PasswordInput
          name="password"
          placeholder="Mot de passe"
          label="Nouveau mot de passe"
          marginForm=""
        />
        <PasswordInput
          name="dPassword"
          placeholder="Mot de passe"
          label="Confirmez le mot de passe"
          marginForm=""
        />
        <FormikSubmitButton className={styles.submitButton}>
          Valider
        </FormikSubmitButton>
        <Callout variant="danger">{error}</Callout>
      </Form>
    </Formik>
  );
}
